import { Right, Left } from "@insightfulscience/shared-utils/either";
import { mapGqlError } from "@insightfulscience/shared-utils/gqlClient/GqlError";
import routes from "../routes";

const expectedErrors = mapGqlError({
	INVOICE_FREE_TRIAL_BIOLOGICS_FAILED: "errors.FREE_TRIAL_BIOLOGICS_FAILED",
});

const onSuccess = routingService => () => routingService.push(routes.freeTrialBiologics.success);

export const requestFreeTrialBiologics = ({ countryID, ...data }) => ({
	routingService,
	subscriptionService,
}) =>
	subscriptionService
		.requestFreeTrialBiologics(data)
		.then(onSuccess(routingService))
		.then(Right)
		.catch(Left.from(expectedErrors));
